import React from 'react';
import { ClassNames } from '@emotion/react';
import type { Row, RowData } from '@tanstack/table-core';
import type { SerializedStyles } from '@emotion/react';
import type { NvTableCellProps } from '.';

type Props<T> = {
  row: Row<T>;
  getCellStyle: (index: number) => SerializedStyles;
  cellMap: Record<string, React.ComponentType<NvTableCellProps<T>>>;
};

const NvTableCells = <T extends RowData>({ row, getCellStyle, cellMap }: Props<T>) => (
  <ClassNames>
    {({ css: classNamesCss }) => (
      <>
        {row.getVisibleCells().map((cell, index) => {
          const CellComponent = cellMap[cell.column.id];
          return (
            <CellComponent
              key={cell.id}
              className={classNamesCss`${getCellStyle(index)}`}
              cell={cell}
            />
          );
        })}
      </>
    )}
  </ClassNames>
);

export default NvTableCells;
